import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NotFoundComponent } from './common/not-found/not-found.component';

import { LoginComponent } from './modules/login/login.component';
import { RegisterComponent } from './modules//login/register/register.component';
import { NewUserComponent } from './modules/login/new-user/new-user.component';
import { LandingPageComponent } from './modules/login/landing-page/landing-page.component';
import { RedeemComponent } from './modules/redeem/redeem.component';
import { DownloadComponent } from './modules/my-content/download/download.component';
import {ViewContentComponent} from './modules/my-content/view-content/view-content.component'
import { FaqComponent } from './modules/faq/faq.component';
import { MyContentComponent } from './modules/my-content/my-content.component';
import { AuthGuard, NewUserGuradService, RouteGuard } from './_services/index';
import { MyAccountComponent } from './modules/my-account/my-account.component';
import { PasswordResetComponent } from './modules/login/password-reset/password-reset.component';
import { PasswordChangeComponent } from './modules/login/password-change/password-change.component';
import { environment } from '../environments/environment';

const appRoutes: Routes = [
    {
        path: 'home',
        component: MyContentComponent,
        canActivate: [AuthGuard],
        // children: [
        //     {path: '', redirectTo: 'download', pathMatch: 'full'},
        //     {path: 'download/:bundleID', component: DownloadComponent},
        // ]
    },
    {
        path: 'download', redirectTo: 'download/', pathMatch: 'full',
        canActivate: [AuthGuard]
    },
    {
        path: 'download/:bundleID/:bundleName/:link/:button/:hover/:active/:imageKey',
        component: DownloadComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'view-content/:key',
        component: ViewContentComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [RouteGuard]
    },
    {
        path: 'landing-page',
        component: LandingPageComponent,
        canActivate: [RouteGuard]
    }, {
        path: 'password-reset',
        component: PasswordResetComponent,
        canActivate: [RouteGuard]
    }, {
        path: 'password-change/:gID/:userID',
        component: PasswordChangeComponent,
    },
    {
        path: 'logout',
        component: LoginComponent
    },
    {
        path: 'my-account',
        component: MyAccountComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'register',
        component: RegisterComponent,
        canActivate: [RouteGuard]
        // canActivate: [NewUserGuradService]
    },
    {
        path: 'new-user',
        component: NewUserComponent,
        canActivate: [RouteGuard]
        // canActivate: [NewUserGuradService]
    },
    {
        path: 'redeem',
        component: RedeemComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'faq',
        component: FaqComponent,
        // canActivate: [AuthGuard]
    },
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    {
        path: '**',
        component: NotFoundComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            appRoutes,
            {
                enableTracing: (!!environment.production && !!environment.staging), // <-- debugging purposes only,
                useHash: true,
                // useHash: false,
            }
        )
    ],
    exports: [
        RouterModule
    ],
    providers: [RouteGuard]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./public/app/app-routing.module.ts